export const BALANCE_PERIOD_DAY = 1;
export const BALANCE_PERIOD_WEEK = 2;
export const BALANCE_PERIOD_MONTH = 3;
export const BALANCE_PERIOD_ALL = 4;

export const BALANCE_MODE_TO_PERIOD_ID = {
  day: BALANCE_PERIOD_DAY,
  week: BALANCE_PERIOD_WEEK,
  month: BALANCE_PERIOD_MONTH,
  general: BALANCE_PERIOD_ALL,
  history: BALANCE_PERIOD_ALL
};

export function resolveBalancePeriodIdByMode(mode) {
  return BALANCE_MODE_TO_PERIOD_ID[mode] || BALANCE_PERIOD_ALL;
}

export const BALANCE_CHART_STEP_DAY = 1;
export const BALANCE_CHART_STEP_WEEK = 2;
export const BALANCE_CHART_STEP_MONTH = 3;

export const BALANCE_MODE_TO_CHART_STEP = {
  day: BALANCE_CHART_STEP_DAY,
  week: BALANCE_CHART_STEP_DAY,
  month: BALANCE_CHART_STEP_WEEK,
  general: BALANCE_CHART_STEP_MONTH,
  history: BALANCE_CHART_STEP_MONTH
};

export function resolveChartStepByMode(mode) {
  return BALANCE_MODE_TO_CHART_STEP[mode] || BALANCE_CHART_STEP_DAY;
}
